import { z } from 'zod';
export var ApplicationAlert = z.object({
  code: z.string(),
  message: z.string(),
  level: z["enum"](['error', 'warning']),
  resource: z["enum"](['application', 'student', 'education', 'exams', 'payment', 'recruitment_partner', 'commission']),
  priority: z["enum"](['high', 'medium']).nullish(),
  link: z.object({
    url: z.string(),
    label: z.string()
  }).optional()
});
export var ApplicationAlertResponse = z.object({
  attributes: z.object({}).passthrough(),
  id: z.string(),
  type: z.literal('application_alert')
});